import { FC } from "react";
import InputSelect from "@common/ui-kit/inputs/input_select";
import { apply } from "@app/data/createEvent/createEventSlice";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import {
	EventModeVariants,
	EventPrivateSelect,
} from "./types";
import { EventModeComponentProps } from '@pages/makeEvent/types'
import { selectEventMode } from "@pages/makeEvent/slice/selectors";
import { setEventMode } from "@pages/makeEvent/slice/MakeEventSlice";
import _ from "lodash";


const fieldValue = 'is_private' as const

const EventModeComponent: FC<EventModeComponentProps> = ({ formik, setValidValue }) => {
	const dispatch = useAppDispatch();
  const eventMode = useAppSelector(selectEventMode);

  const setEventModeCallback = (newValue: EventPrivateSelect) => {
		const { value } = newValue;
		if (_.isBoolean(value)) {
			formik.setFieldValue(fieldValue, value);
			dispatch(setEventMode(newValue));
			dispatch(apply({ [fieldValue]: value }));
			setValidValue(value)
		} else {
			setValidValue(null)
		}
	};

	return (
		<InputSelect
			onChange={setEventModeCallback}
			value={eventMode}
			options={EventModeVariants}
			placeholder={"Открытое/Закрытое"}
			defaultInputValue={""}
			errorText={null}
			handleChange={() => {
			}}
			name={"is_private"}
			onBlur={formik.handleBlur}
			type={"text"}
    />
	)
}

export default EventModeComponent